import { render, staticRenderFns } from "./WechatPublic.vue?vue&type=template&id=03077048&scoped=true&"
import script from "./WechatPublic.vue?vue&type=script&lang=js&"
export * from "./WechatPublic.vue?vue&type=script&lang=js&"
import style0 from "./WechatPublic.vue?vue&type=style&index=0&id=03077048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03077048",
  null
  
)

export default component.exports